import { Requirements } from "@/lib/interfaces/embed";
import { Card } from "../../../ui/components/ui/card";
import { getIcon } from "../icon-map";

function RequirementList({
  title,
  iconKey,
  brandColor,
  items,
}: {
  title: string;
  iconKey: "tick" | "star";
  brandColor: string;
  items: string[];
}) {
  const Icon = getIcon(iconKey);

  return (
    <Card className="p-6 md:p-7 shadow-sm">
      <div className="text-sm font-semibold text-gray-900">{title}</div>
      <div className="mt-4 space-y-3">
        {items.map((text, idx) => (
          <div key={`${title}-${idx}`} className="flex gap-3">
            <div className="pt-0.5">
              {Icon ? (
                <span className="[&>svg]:w-4 [&>svg]:h-4" style={{ color: brandColor }} aria-hidden="true">
                  <Icon />
                </span>
              ) : null}
            </div>
            <div className="text-sm text-gray-600 leading-relaxed">{text}</div>
          </div>
        ))}
      </div>
    </Card>
  );
}

export function JobPostsV2Requirements({
  brandColor,
  requirements,
}: {
  brandColor: string;
  requirements?: Requirements;
}) {
  const necessary = (requirements?.necessary || []).filter(Boolean);
  const preferred = (requirements?.preferred || []).filter(Boolean);

  if (!requirements || (necessary.length === 0 && preferred.length === 0)) return null;

  const hasNecessary = necessary.length > 0;
  const hasPreferred = preferred.length > 0;

  return (
    <div>
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">
          <span>Das bringst </span>
          <span style={{ color: brandColor }}>Du mit</span>
        </h2>
        {requirements.description ? <p className="mt-3 text-sm md:text-base text-gray-600">{requirements.description}</p> : null}
      </div>

      <div className="mt-10">
        {hasNecessary && hasPreferred ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <RequirementList title="Erforderlich" iconKey="tick" brandColor={brandColor} items={necessary} />
            <RequirementList title="Von Vorteil" iconKey="star" brandColor={brandColor} items={preferred} />
          </div>
        ) : (
          <div className="max-w-3xl mx-auto">
            {hasNecessary ? (
              <RequirementList title="Erforderlich" iconKey="tick" brandColor={brandColor} items={necessary} />
            ) : null}
            {hasPreferred ? (
              <RequirementList title="Von Vorteil" iconKey="star" brandColor={brandColor} items={preferred} />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}

